import { Switch, Route, useRouteMatch } from 'react-router-dom';

import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';
import { useCompany } from '@/data/company';

const PreconTeamPage = LoadComponentWithRetry(() => import('./PreconTeamPage'));
const PreconUpsellPage = LoadComponentWithRetry(() => import('./PreconUpsellPage'));

const Routes = () => {
  const { path } = useRouteMatch();
  const company = useCompany();

  // Companies without precon management get the pitch for the whole subtree rather
  // than a redirect, so a shared deep link lands somewhere that explains itself.
  // PreconTeamPage never mounts, so none of its data loads either.
  if (!company.data.is_precon_management) {
    return <PreconUpsellPage />;
  }

  return (
    <Switch>
      <Route path={path} component={PreconTeamPage} />
    </Switch>
  );
};

export default Routes;
